import axios from "axios";
import {AuthenticationResponseDto} from "../dto/AuthenticationResponseDto";

export const loginAPI = async (email: string, password: string) => {
    return await axios.post<AuthenticationResponseDto>(`/api/auth/login`, {
         username: email,
         password: password,
     });
}

export const validateResetToken = async (token: string) => {
    try {
        return await axios.get(
            `/api/auth/validate-reset-token`,
            {
                params: {token: token},
            }
        );
    } catch (error) {
        console.error(`Validate reset token error:`, error);
        throw error;
    }
};

export const postNewPassword = async (token: string, password: string) => {
    return await axios.post<AuthenticationResponseDto>(`/api/auth/reset-password`, {
        token: token,
        newPassword: password,
    });
}